export var PromotionDiscountLevelEnum;
(function (PromotionDiscountLevelEnum) {
    PromotionDiscountLevelEnum["ITEM_BASED"] = "ITEM_BASED";
    PromotionDiscountLevelEnum["CHECK_BASED"] = "CHECK_BASED";
    PromotionDiscountLevelEnum["BOGO"] = "BOGO";
    PromotionDiscountLevelEnum["COMBO"] = "COMBO";
})(PromotionDiscountLevelEnum || (PromotionDiscountLevelEnum = {}));
//# sourceMappingURL=PromotionDiscountLevelEnum.js.map